module.exports = __webpack_public_path__ + "static/media/loggedinhome.35499da3.jpg";